import { render } from "./RoomMessage.vue?vue&type=template&id=b41f09ce&scoped=true"
import script from "./RoomMessage.vue?vue&type=script&lang=js"
export * from "./RoomMessage.vue?vue&type=script&lang=js"

import "./RoomMessage.vue?vue&type=style&index=0&id=b41f09ce&lang=less&scoped=true"

import exportComponent from "/Users/april/Desktop/hz_pro_vue3/mail-task-front-end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b41f09ce"]])

export default __exports__